import React, {Fragment} from 'react';
import Parameter from './Item';
import {Row, Col} from 'reactstrap';

const List = ({parameters, values, errors, onChange}) => {
  parameters.sort((e) => e.ParameterIsMandatory);

  if (parameters.length == 0) {
    return null;
  }

  return (
    <Fragment>
      <h6>Parameters</h6>
      <Row>
        {parameters.map((param, i) => (
          <Col lg="6" key={`param-${i}`}>
            <Parameter
              {...param}
              value={values[param.ParameterName]}
              error={errors[param.ParameterName]}
              onChange={onChange}
            />
          </Col>
        ))}
      </Row>
    </Fragment>
  );
};

export default List;
